<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load" :placeholder="$t('keyword')" />
          <form-select class="mr-1 mb-1" :model="filterFormModel" :options="statusOptionsFilter" attribute="status"></form-select>
          <client-user-group-select class="mr-1 mb-2" :model="filterFormModel"  attribute="groupUser" :client-filter="campaign.client._id" :place-holder="$t('selectGroup')"></client-user-group-select>
          <client-user-select class="mr-1 mb-2" :model="filterFormModel"  attribute="user" :client-filter="campaign.client._id" :group-filter="filterFormModel.group" :place-holder="$t('selectUser')"></client-user-select>
          <time-range-picker class="mr-1 mb-1" :model="filterFormModel" :label="$t('time')" @change="load"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="() => {reset(); load()}" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-6">{{ $t('callTo') }}</div>
          <div class="col-lg-6">{{ $t('callInfo') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-6">
            <div><b>{{item.phone}}</b></div>
            <div v-if="item.name"><span>{{$t('name')}}: </span><b>{{item.name}}</b></div>
            <div v-if="item.desc"><span>{{$t('desc')}}: </span><b>{{item.desc}}</b></div>
            <div>
              <span v-if="!item.finishTime" class="badge badge-danger">{{ $t('notFinished') }}</span>
              <span v-if="item.finishTime > 0" class="badge badge-success">{{ $t('finished') }}</span>
            </div>
            <div><span>{{ $t('createTime') }}:&nbsp;</span><b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b></div>
            <div v-if="item.updateTime"><span>{{ $t('updateTime') }}:&nbsp;</span><b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</b></div>
            <div v-if="item.reviveTime"><span>{{ $t('reviveTime') }}:&nbsp;</span><b>{{ item.reviveTime | moment('DD/MM/YYYY HH:mm:ss') }}</b></div>
            <div v-if="item.revivedBy"><span>{{ $t('revivedBy') }}:&nbsp;</span><b>{{ item.revivedBy.name }} ({{item.revivedBy.email}} - {{item.revivedBy.ext}})</b></div>
          </div>
          <div class="col-lg-6">
            <div>
              <div v-for="(dial, index) in item.dials" :key="dial._id" class="c-info-item">
                <div :class="`row no-gutters bg-light py-2 ${index > 0 ? 'mt-2' : ''}`">
                  <div class="col-md-10">
                    <div>
                      {{ $t("index", [item.dials.length - index]) }}:&nbsp;
                      <span v-if="!dial.status" class="badge badge-danger">{{ $t('notReported') }}</span>
                      <span v-if="dial.status==='ok'" class="badge badge-success">{{ $t(dial.status) }}</span>
                      <span v-if="dial.status==='interest'" class="badge badge-info">{{ $t(dial.status) }}</span>
                      <span v-if="dial.status==='failed'" class="badge badge-dark">{{ $t(dial.status) }}</span>
                      <span v-if="dial.status==='deny' || dial.status==='reject' || dial.status=== 'wrong'" class="badge badge-danger">{{ $t(dial.status) }}</span>
                      <span v-if="dial.status==='silent' || dial.status==='callback'" class="badge badge-warning">{{ $t(dial.status) }}</span>&nbsp;

                      <span v-if="dial.call">
                            <call-detail v-if="dial.call" :callId="dial.call._id" class="mr-1"></call-detail>
                          </span>
                      <span v-else-if="dial.createTime >= (Date.now() - 60 * 60 * 1000)" class="text-gray-999">{{$t('callNotSyncedYet')}}</span>
                    </div>
                    <div v-if="dial.user">
                      {{ $t("agent") }}:&nbsp;
                      <b>
                        <span v-if="dial.userName">{{ dial.userName }}</span>
                        <span v-else>{{$t('na')}}</span>&nbsp;
                        <span v-if="dial.userExt">({{ dial.userExt }})</span>
                        <span v-else>{{$t('na')}}</span>
                      </b>
                    </div>
                    <div v-if="dial.createTime">
                      {{ $t("callTime") }}:&nbsp;
                      <b>{{ dial.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
                    </div>
                    <div v-if="dial.retryTime > 0">
                      {{ $t("retryTime") }}:&nbsp;
                      <b>{{ dial.retryTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>

    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import CallDetail from "./CallDetail";
import TimeRangePicker from "@/components/TimeRangePicker";
import ClientUserSelect from "@/components/ClientUserSelect";
import ClientUserGroupSelect from "@/components/ClientUserGroupSelect2";

export default {
  components: {CallDetail, TimeRangePicker, ClientUserGroupSelect, ClientUserSelect},
  props: ['campaign'],
  mixins: [List, CRUD],
  data() {
    return {
      showList: false,
      autoLoad: true,
      service: 'call-campaign-dial',
      afterLoad: function () {
        this.items.forEach(item => {
          if (item.dials) {
            item.dials.reverse();
          }
        })
      },
      defaultFilterFormModel: {
        client: this.campaign.client._id,
        campaign: this.campaign._id,
        keyword: '',
        status: null,
        statusType: 'dial',
        sort: null,
        groupUser: null,
        page: 1,
        pageSize: 5
      },
      statusOptionsFilter: [
        {value: null, text: this.$t('allResults')},
        {value: 'ok', text: this.$t('ok')},
        {value: 'deny', text: this.$t('deny')},
        {value: 'callback', text: this.$t('callback')},
        {value: 'failed', text: this.$t('failed')},
        {value: 'notReported', text: this.$t('notReported')},
      ],
    }
  },
  i18n: {
    messages: {
      en: {
        callHistory: "Call history",
        callHistoryTitle: "Call history:  ",
        callTo: "Call to",
        callInfo: "Call info",
        index: "Time {0}",
        ok: "Ok",
        deny: "Deny",
        failed: "Failed",
        callback: "Call back",
        notReported: "Chưa báo cáo",
        callTime: "Call at",
        finished: "Finished",
        notFinished: "Not finished",
        allResults: "All results",
      },
      vi: {
        callHistory: "Lịch sử gọi",
        callHistoryTitle: "Lịch sử gọi: ",
        callTo: "Gọi tới",
        callInfo: "Thông tin cuộc gọi",
        index: "Lần {0}",
        ok: "Đồng ý",
        deny: "Từ chối",
        failed: "Thất bại",
        callback: "Hẹn gọi lại",
        notReported: "Chưa báo cáo",
        callTime: "Gọi lúc",
        finished: "Hoàn thành",
        notFinished: "Chưa hoàn thành",
        allResults: "Tất cả kết quả",
        selectGroup: "Chọn nhóm",
        selectUser: "Chọn nhân viên",
      }
    }
  },
  methods: {
  }
}
</script>
<style>
.modal-content-2 {
  background-color: #e5e5e5;
}
</style>
